module.exports = __webpack_public_path__ + "static/emulate3d-3bfb6a69ece21b83be24a8223f28cb2e.png";